<template>
	<div>
		<div class="popBoxBg" v-show="show"></div>
		<div class="popBox" v-show="show">
			<div class="inner">
				<h3>
					请选择读取信息方式
				</h3>
				<ul>
					<li :class="{on:tabIndex==1}" @click="tabIndex=1">
						<img src="../../assets/read-img2.png" >
						<p>社保卡</p>
					</li>
					<li :class="{on:tabIndex==4}" @click="tabIndex=4">
						<img src="../../assets/read-img5.png" >
						<p>医保电子凭证</p>
					</li>
				</ul>
				<div class="fcc">
					<div class="button-blue" @click="close">
						确定
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-pop-read-card',
		// props: {
		// 	msg: String
		// },
		data() {
			return {
				//timer:null,
				show:true,
				tabIndex:1
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			close(){
				this.$emit("click-enter",this.tabIndex)
			}
		},
		beforeDestroy() {
			//clearTimeout(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
		.inner{
			
			text-align: center;
			img{
				width: 264px;
				height: 150px;display: block;
				margin: 0 auto;
				
			}
			p{
				font-size: 31px;
				color: #000;
				line-height: 71px;
			}
			li{
				width: 370px;
				height: 251px;
				padding-top: 31px;
				-webkit-box-sizing: border-box;
				-moz-box-sizing: border-box;
				box-sizing: border-box;
				margin: 0 auto;
				border-radius: 10px;
				margin-bottom: 43px;
				cursor: pointer;
				&.on{
					background: #01A0A0;
					p{
						color: #fff;
					}
				}
			}
			li+li{
				margin-bottom: 42px;
			}
			h3{
				font-size: 38px;
				
				font-weight: 800;
				color: #333333;
				padding-top: 38px;
				padding-bottom: 52px;
			}
		}
</style>
